<template>
    <div>
        <div class="relative" v-if="show && !loading">
            <input
                class="input pl-8"
                :class="[validation === false ? 'border-red-500' : '']"
                :placeholder="__('Número completo incluindo código do país')"
                :value="value"
                @input="$emit('input', $event.target.value)"
                @blur="checkValue()"
            />

            <div class="absolute inset-y-0 left-0 flex items-center mx-2">
                <alo-icon icon="custom-whatsapp" class="w-4 h-4 text-gray-500" />
            </div>
        </div>

        <div v-if="loading">
            <alo-loading-ring />
        </div>

        <div v-show="validation === false" class="text-sm">
            {{ __('Número de whatsapp inválido.') }}
        </div>
    </div>
</template>

<script>
export default {
    props: ['value'],
    data() {
        return {
            loading: true,
            show: true,
            validation: null,
        }
    },
    async mounted() {
        try {
            let { data } = await axios.get('/integracao/api_interna/whatsapp_web_counter')
            this.show = data.count > 0
            if (!this.show) this.$emit('hide')
        } finally {
            this.loading = false
        }
    },
    methods: {
        async checkValue() {
            this.$emit('blur')

            if (this.value) {
                let { data } = await axios.get('/integracao/api_interna/whatsapp_jid_validation', {
                    params: {
                        jid: this.value,
                    },
                })

                this.validation = data.status
            } else {
                this.validation = null
            }
        },
    },
}
</script>
